




























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import {
  ClaimType,
  LinkedClaim
} from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useClaimStore } from "@/employee/store/claim";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
    GenericLoadingSpinner
  },
})
export default class LinkedClaimRow extends Vue {
  claimStore = useClaimStore();

  @Prop() linkedClaim: LinkedClaim;

  @Prop() index: number;

  @Prop()
  onLinkRemoved: () => void;

  ClaimType = ClaimType;
  moment = moment;
  formatCurrency = formatCurrency;
  noteIsVisible = false;

  removeLink (claimNumber: string) {
    this.claimStore.removeExpenseToClaimLink({
      claimNumber,
      expenseId: this.linkedClaim.expenseId
    }).then(() => {
      this.onLinkRemoved();
    });
  }

  isAltRow (rowId: number): boolean {
    return rowId % 2 === 0;
  }

  toggleNoteVisible () {
    this.noteIsVisible = !this.noteIsVisible;
  }

  formattedServiceDate (serviceDate: string): string {
    return moment(serviceDate).format("MMM D, YYYY");
  }
}
